export const makeQueryKeys = {
	apiKeys: {
		all: () => ['api-keys'] as const,
		list: (filters?: { page: number; status: string }) =>
			['api-keys', 'list', filters] as const
	},
	auth: {
		all: () => ['auth'] as const,
		landingSession: () => ['auth', 'landing-session'] as const,
		session: () => ['auth', 'session'] as const,
		sessions: () => ['auth', 'sessions'] as const,
		socialProviders: () => ['auth', 'social-providers'] as const,
		totpAuthenticators: () => ['auth', 'totp-authenticators'] as const
	},
	billing: {
		all: () => ['billing'] as const,
		subscription: () => ['billing', 'subscription'] as const,
		usage: () => ['billing', 'usage'] as const,
		analytics: {
			all: () => ['billing', 'analytics'] as const,
			summary: () => ['billing', 'analytics', 'summary'] as const,
			timeseries: (range: '7d') =>
				['billing', 'analytics', 'timeseries', range] as const,
			logs: (limit: number) =>
				['billing', 'analytics', 'logs', { limit }] as const
		}
	},
	users: {
		me: () => ['users', 'me'] as const,
		preferences: () => ['users', 'preferences'] as const
	}
} as const
